import { Component, Inject } from '@angular/core';
import { ListBase } from "../shared/list.base";
import { CrewPermissionsService } from '../../core/crew-permissions.service';

@Component({
    selector: 'crew-summationgroups',
    template: require('../shared/list-view.html')
})
export class SummationGroups extends ListBase<Nema.Crew.Model.ActivityTypeSummationGroup>  {
    constructor(
        @Inject("summationGroups") summationGroups: Nema.Crew.Model.ActivityTypeSummationGroup[],
        crewPermissionsService: CrewPermissionsService) {

        super(summationGroups, crewPermissionsService);
    }

    public newEntityState = "app.settings.summationgroups.new";

    public editEntityState = "app.settings.summationgroups.detail";

    public entityName = "Activity Summation Group";

    public entityNames = "Activity Summation Groups";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/summationgroups/summation-groups.component.ts